import type { AnonCart } from "../../model/AnonCartTypes";
import type { AnonCartEvent } from "./AnonCartEvents";
import { AnonCartStoreImpl } from "./AnonCartStore";
import { Store } from "../../utils/Store";
import { AnonCartActions } from "../../actions/AnonCartActions";
import * as AnonCartServerRequests from "../../server/AnonCartServerRequests";
export type AnonCartDebugPageStoreState = {
	cart: AnonCart;
	localEvents: AnonCartEvent[];
	serverEvents: AnonCartEvent[];
};
export class AnonCartDebugPageStoreImpl extends Store {
	anonCartStore: AnonCartStoreImpl;
	_state: {
		serverEvents: AnonCartEvent[];
	};

	constructor(anonCartStore: AnonCartStoreImpl) {
		super();
		this.anonCartStore = anonCartStore;
		this._state = {
			serverEvents: []
		};
		this.listenTo(anonCartStore, () => this.trigger());
		this.listenTo(AnonCartActions.fetchEvents, () => {
			this.handleFetchEvents().catch((error) => {
				console.error("handleFetchEvents in AnonCartDebugPageStore failed with ", error);
			});
		});
	}

	_getEventsInOrder(applied: AnonCartEvent[], pending: AnonCartEvent[]): AnonCartEvent[] {
		return [...applied, ...pending].sort((a, b) => b.seqNum - a.seqNum);
	}

	async handleFetchEvents() {
		const cartId = this.anonCartStore.getAnonCart().cartId;

		if (cartId !== "DUMMY") {
			this._state.serverEvents = await AnonCartServerRequests.getEvents({
				cartId
			});
		} else {
			this._state.serverEvents = [];
		}

		this.trigger();
	}

	getState(): AnonCartDebugPageStoreState {
		const cart = this.anonCartStore.getAnonCart();
		return {
			cart,
			localEvents: this._getEventsInOrder(
				this.anonCartStore.getAppliedEvents(),
				this.anonCartStore.getPendingEvents()
			),
			serverEvents: this._state.serverEvents
		};
	}
}
